import * as Actions from "auth/store/actions";

const initialState = {
  success: false,
  isForgotPassLoading: false,
  errorForgotPass: null,
  data: null,
};

const forgot = (state = initialState, action) => {
  switch (action.type) {
    case Actions.FORGOT_PASS_FETCH_START: {
      return {
        ...initialState,
        isForgotPassLoading: true,
      };
    }
    case Actions.FORGOT_PASS_FETCH_SUCCESS: {
      return {
        ...initialState,
        success: true,
        isForgotPassLoading: false,
        data: action.payload.data,
      };
    }
    case Actions.FORGOT_PASS_FETCH_FAILURE: {
      return {
        success: false,
        isForgotPassLoading: false,
        errorForgotPass: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

export default forgot;
